module.exports = __webpack_public_path__ + "img/pizza-slice.2b7bd03c.svg";